import React from "react";
import videojs from "video.js";
import VideoPlayer from "./Video";

const VideoHLSWrapper = ({ src }) => {
  const playerRef = React.useRef(null);

  const videoJsOptions = {
    // autoplay: true,
    controls: true,
    responsive: true,
    fluid: true,
    poster: "/assets/img/video-bg.jpg",
    sources: [
      {
        src,
        type: "application/x-mpegURL",
      },
    ],
  };

  const handlePlayerReady = (player) => {
    playerRef.current = player;

    // You can handle player events here, for example:
    player.on("waiting", () => {
      videojs.log("player is waiting");
    });

    player.on("dispose", () => {
      videojs.log("player will dispose");
    });
  };

  return (
    <>
      <VideoPlayer options={videoJsOptions} onReady={handlePlayerReady} />
    </>
  );
};

export default VideoHLSWrapper;
